
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"heading":"Verbindung zum Cadenza-Web-Server nicht möglich","msg":"Bitte prüfen Sie Ihre Netzwerkverbindung. Sobald die Verbindung verfügbar ist, werden Sie automatisch verbunden.","primaryBtn":"Verbinden"},"en":{"heading":"Unable to connect to the Cadenza Web server","msg":"Please check your network connection. As soon as the connection is available, you will be automatically connected.","primaryBtn":"Connect"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();